// extracted by mini-css-extract-plugin
export var avatarContainer = "_c2-0";
export var avatarTypingWave = "_c2-i";
export var gray = "_c2-f";
export var green = "_c2-c";
export var icon = "_c2-9";
export var image = "_c2-1";
export var lg = "_c2-6";
export var md = "_c2-5";
export var presenceDot = "_c2-b";
export var red = "_c2-d";
export var sm = "_c2-4";
export var status = "_c2-a";
export var typingDot = "_c2-h";
export var typingPill = "_c2-g";
export var xl = "_c2-7";
export var xs = "_c2-3";
export var xxl = "_c2-8";
export var xxs = "_c2-2";
export var yellow = "_c2-e";